"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultReactOptions = void 0;
/**
 * Contains default values for the `reactOptions` object.
 */

exports.defaultReactOptions = {
  useCamelCaseFlagKeys: true
};